var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayStatus)?_c('div',{staticClass:"status-badge",class:['status-' + _vm.displayStatus.detailed_status]},[_vm._v(" "+_vm._s(_vm.displayStatusText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }